// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
  min-height: calc( 100vh - 62px);
  max-width: 690px; }
  .login-container .avatar {
    width: 100%;
    border-radius: 0;
    background: none;
    margin-bottom: 56px; }
    @media (min-width: 768px) {
      .login-container .avatar {
        margin-bottom: 95px; } }
  .login-container .login-form {
    width: 100%;
    max-width: 100%; }
    .login-container .login-form .login-field {
      margin: 0; }
      .login-container .login-form .login-field:nth-child(2) {
        margin: 15px 0; }
      .login-container .login-form .login-field label {
        font-size: 19px;
        line-height: 25px; }
      .login-container .login-form .login-field input {
        padding: 13px 0; }
    .login-container .login-form .mui-checkbox {
      width: 100%; }
    .login-container .login-form .submit-btn {
      font-size: 19px;
      width: 100%;
      margin-top: 40px; }
      @media (min-width: 768px) {
        .login-container .login-form .submit-btn {
          margin-top: 100px; } }
    .login-container .login-form .form-links {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between; }
      .login-container .login-form .form-links .MuiGrid-item {
        width: 100%; }
        @media (min-width: 480px) {
          .login-container .login-form .form-links .MuiGrid-item {
            width: 50%; }
            .login-container .login-form .form-links .MuiGrid-item.signup-link {
              text-align: right; } }
        .login-container .login-form .form-links .MuiGrid-item a:hover {
          color: var(--color-yellow) !important;
          text-decoration: none; }
    .login-container .login-form .forgot-password {
      color: white !important;
      font-size: 17px;
      text-decoration-line: underline;
      cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.scss"],"names":[],"mappings":"AAAA;EACI,+BAAgC;EAChC,gBAAgB,EAAA;EAFpB;IAIQ,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB,EAAA;IACnB;MARR;QASY,mBAAmB,EAAA,EAE1B;EAXL;IAaQ,WAAW;IACX,eAAe,EAAA;IAdvB;MAgBY,SAAS,EAAA;MAhBrB;QAkBgB,cAAc,EAAA;MAlB9B;QAqBgB,eAAe;QACf,iBAAiB,EAAA;MAtBjC;QAyBgB,eAAe,EAAA;IAzB/B;MA6BY,WAAW,EAAA;IA7BvB;MAgCY,eAAe;MACf,WAAW;MACX,gBAAgB,EAAA;MAChB;QAnCZ;UAoCgB,iBAAiB,EAAA,EAExB;IAtCT;MAwCY,aAAa;MACb,eAAe;MACf,8BAA8B,EAAA;MA1C1C;QA4CgB,WAAW,EAAA;QACX;UA7ChB;YA8CoB,UAAU,EAAA;YA9C9B;cAgDwB,iBAAiB,EAAA,EACpB;QAjDrB;UAqDwB,qCAAqC;UACrC,qBAAqB,EAAA;IAtD7C;MA4DY,uBAAuB;MACvB,eAAe;MACf,+BAA+B;MAC/B,eAAe,EAAA","sourcesContent":[".login-container{\n    min-height: calc( 100vh - 62px );\n    max-width: 690px;\n    .avatar{\n        width: 100%;\n        border-radius: 0;\n        background: none;\n        margin-bottom: 56px;\n        @media (min-width : 768px ){\n            margin-bottom: 95px;\n        }\n    }\n    .login-form{\n        width: 100%;\n        max-width: 100%;\n        .login-field{\n            margin: 0;\n            &:nth-child(2){\n                margin: 15px 0;\n            }\n            label{\n                font-size: 19px;\n                line-height: 25px;\n            }\n            input{\n                padding: 13px 0;\n            }\n        }\n        .mui-checkbox{\n            width: 100%;\n        }\n        .submit-btn{\n            font-size: 19px;\n            width: 100%;\n            margin-top: 40px;\n            @media (min-width : 768px ){\n                margin-top: 100px;\n            }\n        }\n        .form-links{\n            display: flex;\n            flex-wrap: wrap;\n            justify-content: space-between;\n            .MuiGrid-item{\n                width: 100%;\n                @media (min-width : 480px ){\n                    width: 50%;\n                    &.signup-link{\n                        text-align: right;\n                    }\n                }\n                a{\n                    &:hover{\n                        color: var(--color-yellow) !important;\n                        text-decoration: none;\n                    }\n                }\n            }\n        }\n        .forgot-password {\n            color: white !important;\n            font-size: 17px;\n            text-decoration-line: underline;\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
